const theme = {
  primary: "rgb(85, 134, 157)",
  secondary: "rgb(149, 56, 32)",
};

export default theme;
